import { render, staticRenderFns } from "./SeccionBodegaComponent.vue?vue&type=template&id=6f7d6a4d&"
import script from "./SeccionBodegaComponent.vue?vue&type=script&lang=js&"
export * from "./SeccionBodegaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports